import persist from './persist'
import axios from 'axios'
// import { NotUnique } from '../errors/bucketErrors'
// import { axapi } from '../helpers/axinstance'
// import router from '../router/index'

export default {
  state: {
    customerMemberships: [],
  },
  mutations: {
  },
  actions: {
    // Customer Accounts
    async getAccountMemberships ({ state, commit, dispatch }) {
      try {
        const { data } = await axios.get(`${process.env.VUE_APP_API_URL}/api/v1/organization/acct-memberships`)
        console.log(data)
        state.customerMemberships = data
        return data
      } catch (error) {
        await dispatch('processAxiosError', error)
        console.log(error)
        return []
      }
    },

  },
  getters: {
    customerMemberships: state => state.customerMemberships,
  },
  plugins: [persist.plugin],
}
